var _path, _path2, _path3, _path4, _circle, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M1.28997 27.0153V28.5381H3.36602V29.4702H1.28997V31.9001H0V26.0999H3.66836V27.0153H1.28997Z",
    fill: "#0973F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M7.15398 32C6.52915 32 5.9967 31.8779 5.55663 31.6338C5.11656 31.387 4.78399 31.0388 4.55892 30.5895C4.33384 30.1373 4.22131 29.6061 4.22131 28.9958C4.22131 28.3911 4.33216 27.8641 4.55388 27.4147C4.77895 26.9626 5.10816 26.6144 5.54151 26.3703C5.97822 26.1234 6.50563 26 7.12375 26C7.76537 26 8.30622 26.1248 8.74629 26.3745C9.18636 26.6214 9.51557 26.9695 9.73392 27.4189C9.95564 27.8682 10.0665 28.3939 10.0665 28.9958C10.0665 29.6061 9.95228 30.1373 9.72385 30.5895C9.49877 31.0388 9.16788 31.387 8.73117 31.6338C8.29446 31.8779 7.76873 32 7.15398 32ZM7.15398 31.1096C7.45296 31.1096 7.72002 31.0305 7.95517 30.8724C8.19368 30.7143 8.38181 30.4743 8.51954 30.1526C8.65727 29.8308 8.72613 29.4369 8.72613 28.9709C8.72613 28.2857 8.58504 27.7642 8.30286 27.4064C8.02404 27.0458 7.631 26.8655 7.12375 26.8655C6.62993 26.8655 6.24697 27.0458 5.97486 27.4064C5.70612 27.7642 5.57175 28.2885 5.57175 28.9792C5.57175 29.4508 5.63557 29.846 5.76323 30.165C5.89424 30.4813 6.07732 30.7184 6.31247 30.8766C6.55098 31.0319 6.83149 31.1096 7.15398 31.1096Z",
    fill: "#0973F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M14.392 31.9001L12.588 29.8031V31.9001H11.3081V26.0999H13.2632C14.9295 26.0999 15.7626 26.7157 15.7626 27.9473C15.7626 28.2219 15.7088 28.4924 15.6013 28.7587C15.4938 29.0222 15.3175 29.2566 15.0722 29.4619C14.8304 29.6671 14.5196 29.8086 14.14 29.8863L15.954 31.9001H14.392ZM13.1221 29.2788C13.4077 29.2788 13.6512 29.2233 13.8528 29.1123C14.0577 28.9986 14.2122 28.8488 14.3164 28.663C14.4205 28.4743 14.4726 28.2691 14.4726 28.0472C14.4726 27.6644 14.3651 27.3828 14.1501 27.2025C13.9385 27.0222 13.5857 26.932 13.0919 26.932H12.588V29.2788H13.1221Z",
    fill: "#0973F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M23 26V31.9001H21.7503V29.4119L21.7957 28.43L21.4379 28.8793L20.0573 30.2191L18.6766 28.8793L18.3188 28.43L18.3742 29.4119V31.9001H17.1246V26H17.2254L20.0673 28.767L22.8891 26H23Z",
    fill: "#0973F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 3,
    stroke: "#00AEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31531 12H10",
    stroke: "#00AEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3153 12H23",
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSlider);
export default __webpack_public_path__ + "static/media/formSlider.7468b387.svg";
export { ForwardRef as ReactComponent };